import { routeToSpecificScope } from '../../helpers/helpersts';
import * as TYPES from '../types';
import { requestData } from '../../config/services/datasets';
import { addLoadingFlag, changeMessageLoading, subLoadingFlag } from './loading';
import { SERVER } from '../../config/server.config';
import { paramBuilder } from '../../helpers/helpers';
import { MESSAGES } from '../../config/constants';
import { CustomerPlayersType, LiveSpeedsLog, PlayerAction, PlayersExcludedByPeriodType} from '../types';
import { LiveSpeedsPlayerList } from 'components/Viewer/LiveSpeedsModal/types';
import { AppThunk, Player } from '../../config/commonTypes';
import { message } from 'antd';

// Customer players
export const replaceCustomerPlayers = (teamId: string | number, customerPlayers: CustomerPlayersType[]) => {
  return {
    type: PlayerAction.REPLACE_CUSTOMERS_PLAYERS,
    teamId, customerPlayers
  };
};

export const getCustomerPlayers = (id: string | number, league: string, dateRange?: string): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    let params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    params = { ...params, league: { value: { value: league } } };
    params.positions = [];
    const results = await requestData(SERVER.ACCOUNT_SETTINGS(id) + paramBuilder(params)+'&compareRange='+dateRange);
    if (results && results[0]) {
      const customerPlayers: CustomerPlayersType[] = [];
      Object.keys(results[0]).forEach((key) => {
        customerPlayers.push({ ...results[0][key], key });
      });
      if (customerPlayers.length === 0) {
        dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
      }
      dispatch(replaceCustomerPlayers(id, customerPlayers));
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const setPlayerSpeed = (id:string, player: CustomerPlayersType | Player, speed: number|string, league:string, dateRange:string): AppThunk => {
  return (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const body = {
      teamId: id,
      players: {
        [player.key]: {
          position: player.position,
          positionGroup: player.positionGroup,
          speed: speed,
          name: player.name
        }
      }
    };
    const jsonBody = JSON.stringify(body);
    fetch(SERVER.ACCOUNT_SETTINGS(id), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then(responseJson => {
        dispatch(getCustomerPlayers(id, league, dateRange));
      })
      .finally(() => {
        dispatch(subLoadingFlag(scope));
      });
  };
};

export const setPlayerCustomSpeed = (id: string | number, player: CustomerPlayersType | Player, customTargetSpeed: number|string, league: string, day: string): AppThunk => {
  return (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const body = {
      teamId: id,
      players: {
        [player.key]: {
          position: player.position,
          positionGroup: player.positionGroup,
          customTargetSpeed: customTargetSpeed,
          name: player.name,
          day
        }
      }
    };
    const jsonBody = JSON.stringify(body);
    fetch(SERVER.ACCOUNT_SETTINGS(id), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then(responseJson => {
        dispatch(getCustomerPlayers(id, league, day));
      })
      .finally(() => {
        dispatch(subLoadingFlag(scope));
      });
  };
};
  // TODO LOCAL STORAGE PLAYERS EXCLUDED
export const excludePlayers = (gameId: string, excluded: string[]) => {
      return{
        type: PlayerAction.EXCLUDE_PLAYERS,
        gameId,
        playersExcluded: excluded,
      };
};

export const updateLiveSpeeds = (players: LiveSpeedsPlayerList, teamId: string, dsid: string) => {
     
      const body = {
      teamId: teamId,
      nids: players.map(p => ({
      [p.id]: {
        name: p.name,
        max: (Number(p.max) === 0 || !p.max) ? -1 : Number(p.max),
        maxS: (Number(p.maxS) === 0 || !p.maxS) ? -1 : Number(p.maxS)
    },
  })),
    dsid: dsid
    };
    const jsonBody = JSON.stringify(body);
    fetch(SERVER.LIVE_SPEEDS_UPDATE(dsid), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          message.error(
          {
            content: "Error Saving Live Speeds",
            className: "message-pro-error",
            style: {
              marginTop: "60vh",
            },
          },
          10
        );
          throw Error(response.statusText);
          
        }
        message.success(
        {
          content: "Live Speeds Successfully Saved",
          className: "message-pro",
          style: {
            marginTop: "60vh",
          },
        },
        10
      );
        return response.json();
      });
  
};

export const setLiveSpeedsLog = (liveSpeedsData: LiveSpeedsLog[]) => {
  return {
    type: PlayerAction.UPDATE_LIVE_SPEEDS,
    liveSpeedsData
  };
};

export const getLiveSpeeds = (dsId: string): AppThunk => {
     return async (dispatch) => {
    const results = await requestData(SERVER.LIVE_SPEEDS_UPDATE(dsId));
    if (results && results[0]) {
      const liveSpeedsData = JSON.parse(results);
      dispatch(setLiveSpeedsLog(liveSpeedsData));
    }
  };
};

export const setPlayersExcludedByPeriod = (
  playersExcludedByPeriod: PlayersExcludedByPeriodType[]
) => ({
  type: PlayerAction.SET_EXCLUDE_PLAYERS_BY_PERIOD,
  playersExcludedByPeriod,
});

export const savePlayersExcludedByPeriod = (
  dsid: string,
  players: PlayersExcludedByPeriodType[]
): AppThunk => {
  return async (dispatch) => {
    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        dsid,
        players,
      }),
    };

    const response = await fetch(SERVER.SET_EXCLUDE_PLAYERS(), request);
    const data = await response.json();
    if (data.code === 1) {
      dispatch(setPlayersExcludedByPeriod(players));
    } else {
      throw new Error(data.message);
    }
  };
};

export const loadPlayersExcludedByPeriod = (dsid: string): AppThunk => {
  return async (dispatch) => {
    const results = await requestData(SERVER.GET_EXCLUDE_PLAYERS(dsid));
    if (results) {
      dispatch(setPlayersExcludedByPeriod(results));
    }
  };
};
